import React from "react"
import Feature from "./Feature"
import { Upload, FileText, Clock } from "react-feather"

export const About = () => {
  return (
    <>
      <div id="about" className="text-center bg-black text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-center">Quick solutions, less stress</h1>
          </div>
          <div className="flex flex-wrap justify-center gap-12">
            <Feature
              icon={<Upload size={24} />}
              headline="Upload class material"
              description="Upload your class's pdfs and study guides that you want the cheat sheet to be based on"
            />
            <Feature
              icon={<FileText size={24} />}
              headline="Customize your sheet"
              description="Select how many pages you want your cheat sheet to be, and tell the AI what topics to emphasize in your cheat sheet"
            />
            <Feature
              icon={<Clock size={24} />}
              headline="Fast results"
              description="Recieve your sheet in minutes, saving you the hours of creating the sheet."
            />
          </div>
        </div>
      </div>
      <div className="relative h-24 bg-black">
        <div 
          className="absolute w-full h-24 bg-white transform -skew-y-3"
          style={{ transformOrigin: 'top right' }}
        />
      </div>
    </>
  )
}

